/**
 * This file provided by Facebook is for non-commercial testing and evaluation
 * purposes only. Facebook reserves all rights not expressly granted.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * FACEBOOK BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
 * ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

// eslint-disable-next-line strict
'use strict';

import FixedDataTable from 'fixed-data-table';
import React from 'react';
import Currencies from '../../../utils/Currencies';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';

const { Table, Column, ColumnGroup, Cell } = FixedDataTable;

// const DateCell = ({rowIndex, data, col, ...props}) => (
//   <Cell {...props}>
//     {data.getObjectAt(rowIndex)[col].toLocaleString()}
//   </Cell>
// );
//
// const ImageCell = ({rowIndex, data, col, ...props}) => (
//   <ExampleImage
//     src={data.getObjectAt(rowIndex)[col]}
//   />
// );
//
// const LinkCell = ({rowIndex, data, col, ...props}) => (
//   <Cell {...props}>
//     <a href="#">{data.getObjectAt(rowIndex)[col]}</a>
//   </Cell>
// );

const TextCell = ({ rowIndex, data, col, ...props }) =>
	props.currency ? (
		<Cell {..._.omit(props, ['currency', 'cellClass'])}>
			<span className={'cell-span ' + props.cellClass}>
				{Currencies.getSymbol(props.currency)}
				{data[rowIndex][col].toLocaleString()}
			</span>
		</Cell>
	) : (
		<Cell {..._.omit(props, ['currency', 'cellClass'])}>
			<span className={'cell-span ' + props.cellClass}>{data[rowIndex][col]}</span>
		</Cell>
	);

class TopCitiesTable extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			dataList: props.data,
		};

		this.displayName = 'TopCitiesTable';
	}

	componentDidUpdate(prevProps) {
		if (this.props.dataList !== prevProps.dataList) {
			this.setState({
				dataList: this.props.dataList,
			});
		}
	}

	render() {
		const { t } = this.props;
		var { dataList } = this.state;
		var unifiedHeight = 30;

		//466
		var cityNameHeight = 176;
		var number_of_room_nights_height = 64;
		var averagePricePerNightHeight = 128;
		var totalSpendHeight = 128;

		var cityNameProps = _.extend({}, this.props, {
			cellClass: 'city-name',
		});

		var number_of_room_nights_props = _.extend({}, this.props, {
			cellClass: 'number-of-room-nights',
		});

		var averagePricePerNightProps = _.extend({}, this.props, {
			cellClass: 'average-price-per-night',
			// currency: this.props.currency
		});

		var totalSpentProps = _.extend({}, this.props, {
			cellClass: 'total-spent',
			// currency: this.props.currency
		});

		return (
			<Table
				rowHeight={unifiedHeight}
				groupHeaderHeight={unifiedHeight}
				headerHeight={unifiedHeight}
				rowsCount={dataList.length}
				width={cityNameHeight + number_of_room_nights_height + averagePricePerNightHeight + totalSpendHeight}
				height={dataList.length * unifiedHeight + 2 * unifiedHeight + 2}
				{...this.props}
			>
				{/*<Column*/}
				{/*cell={<ImageCell data={dataList} col="avatar" />}*/}
				{/*fixed={true}*/}
				{/*width={50}*/}
				{/*/>*/}
				{/*<Column*/}
				{/*header={<Cell>First Name</Cell>}*/}
				{/*cell={<LinkCell data={dataList} col="firstName" />}*/}
				{/*fixed={true}*/}
				{/*width={100}*/}
				{/*/>*/}
				{/*<Column*/}
				{/*header={<Cell>Last Name</Cell>}*/}
				{/*cell={<TextCell data={dataList} col="lastName" />}*/}
				{/*fixed={true}*/}
				{/*width={100}*/}
				{/*/>*/}
				<ColumnGroup
					fixed={true}
					header={
						<Cell className="table-header">
							<span className="table-title">{t('TopDestinations')}</span>
							<span className="table-sort">{t('ByRoomNights')}</span>
						</Cell>
					}
				>
					<Column
						header={<Cell className="column-header">{t('City')}</Cell>}
						cell={<TextCell data={dataList} col="name" {..._.omit(cityNameProps, 'currency')} />}
						fixed={true}
						width={cityNameHeight}
					/>
					<Column
						header={<Cell className="column-header">{t('Nights')}</Cell>}
						cell={
							<TextCell
								data={dataList}
								col="total_room_nights"
								{..._.omit(number_of_room_nights_props, 'currency')}
							/>
						}
						fixed={true}
						width={number_of_room_nights_height}
					/>
					<Column
						header={<Cell className="column-header">{t('AvgNightlyRate')}</Cell>}
						cell={<TextCell data={dataList} col="averagePricePerNight" {...averagePricePerNightProps} />}
						fixed={true}
						width={averagePricePerNightHeight}
					/>
					<Column
						header={<Cell className="column-header">{t('TotalCost')}</Cell>}
						cell={<TextCell data={dataList} col="totalSpent" {...totalSpentProps} />}
						fixed={true}
						width={totalSpendHeight}
					/>
				</ColumnGroup>
			</Table>
		);
	}
}

export default withTranslation()(TopCitiesTable);
